import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['content', 'input'];
  declare hasContentTarget: boolean;
  declare contentTarget: HTMLDivElement;
  declare inputTarget: HTMLInputElement;

  connect(): void {
    this.trigger();
  }

  trigger(): void {
    if (!this.hasContentTarget) return;

    this.contentTarget.hidden = !this.inputTarget.checked;
  }
}
